import React from 'react';
import AgentConversation from '../../agents/shared/AgentConversation';
import { incidentAnalystSpec } from './spec';

/**
 * Thin wrapper — the chat implementation is the shared
 * AgentConversation (one chat for every agent, no duplication).
 * The Incident Analyst's rich MessageBubble + detail-card tools are
 * supplied via `incidentAnalystSpec`.
 */
const ConversationPage: React.FC = () => (
  <AgentConversation spec={incidentAnalystSpec} />
);

export default ConversationPage;
